import NotificationDrawer from '@/components/Drawer/NotificationDrawer'
import {CountrySelector} from '@/components/JourneyEditor/components/CountrySelector'
import {ROUTES} from '@/config/constants'
import {getApplications} from '@/helpers/envConfig'
import {useCountries} from '@/hooks/useCountries'
import {ApplicationSelector} from '@/shared-components/ApplicationSelector/ApplicationSelector'
import {useAppDispatch, useAppSelector} from '@/store'
import {selectApplication, selectShellActive, setApplication} from '@/store/slices/commonSlice'
import {JourneyStatus} from '@/types/JourneyStatus'
import {setJourneyMeta} from '@ReduxActions'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {useLocation, useNavigate} from 'react-router-dom'
import NotificationList from './NotificationList'

export default function TriggerBasedNotification(): React.JSX.Element {
  const {formatMessage} = useIntl()
  const dispatch = useAppDispatch()
  const shellActive = useAppSelector(selectShellActive)
  const application = useAppSelector(selectApplication)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const {countries, country} = useCountries()
  const applications = getApplications()

  const navigate = useNavigate()
  const {pathname} = useLocation()
  const isEditing = pathname?.includes('/edit')

  const onSetIsOpen = (value: boolean) => {
    setIsOpen(value)

    if (!value) {
      navigate(ROUTES.EVENT_NOTIFICATIONS)
    }
  }

  const onCountryDidChange = (value: string) => {
    dispatch(setJourneyMeta({country: value}))
  }

  const onApplicationDidChange = (value: string) => {
    dispatch(setApplication(value))
  }

  return (
    <div className="mt-5 grid gap-4" data-testid="trigger-based-notification-container">
      <div className="flex items-center justify-between">
        <p className="text-3xl font-bold text-text-primary">Welcome Back, User!</p>
        {!shellActive && (
          <div className="right-0 flex flex-row items-center gap-2 text-xs font-normal">
            <p className="text-nowrap text-text-primary">{formatMessage({id: 'GENERAL.SELECT_APPLICATION'})}</p>
            <ApplicationSelector
              id="main-application"
              applications={applications}
              value={application}
              onValueChanged={onApplicationDidChange}
            />
            <p className="ml-4 text-nowrap text-text-primary">{formatMessage({id: 'GENERAL.SELECT_MARKET'})}</p>
            <CountrySelector
              id="main-country"
              status={JourneyStatus.draft}
              countries={countries}
              value={country}
              onValueChanged={onCountryDidChange}
            />
          </div>
        )}
      </div>

      <div className="grid">
        <NotificationList setIsOpen={setIsOpen} />
      </div>
      <NotificationDrawer isOpen={isOpen || isEditing} setIsOpen={onSetIsOpen} />
    </div>
  )
}
